import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { optionProductsByProducts } from "../Options";
import Sidebar from "../Sidebar";
import Multiselect from "multiselect-react-dropdown";
import { jwtDecode } from "jwt-decode";
import InputFieldPerCotton from "./InputField";
export default function PriceFormHerbals() {
  const [date, setDate] = useState("2023-08-09");
  //options
  const [selectedOptions, setSelectedOptions] = useState([]);
  //min-max states
  const [check, setCheck] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(false);
  //province items
  const [options, setOptions] = useState([]);
  const [ajwain, setAjwain] = useState({
    by_product_id: "80",
    by_product: "Ajwain",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [honey, setHoney] = useState({
    by_product_id: "77",
    by_product: "Honey",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [ispaghol, setIspaghol] = useState({
    by_product_id: "78",
    by_product: "Ispaghol",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [kalonji, setKalonji] = useState({
    by_product_id: "79",
    by_product: "Kalonji",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [saunf, setSaunf] = useState({
    by_product_id: "82",
    by_product: "Saunf",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [tukhMalanga, setTukhMalanga] = useState({
    by_product_id: "81",
    by_product: "Tukh Malanga",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });

  const all = [
    ajwain,
    honey,
    ispaghol,
    kalonji,
    saunf,
    tukhMalanga,
  ];

  //references
  const stationRef = useRef(null);

  useEffect(() => {
    const preventNumberInputScroll = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", preventNumberInputScroll, {
      passive: false,
    });

    return () => {
      document.removeEventListener("wheel", preventNumberInputScroll);
    };
  }, []);

  const nav = useNavigate();

  const navigateToPrices = () => {
    nav("/prices");
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  useEffect(() => {
    let k = 0;
    for (let i = 0; i < all.length; i++) {
      if (Number(all[i].minimum) > Number(all[i].maximum)) {
        k++;
      } else k = k;
    }
    if (k > 0) {
      setDisplayMessage(true);
      setCheck(false);
    } else {
      setDisplayMessage(false);
      setCheck(true);
    }
  }, [all]);

  const token = sessionStorage.getItem("token");
  const ferrit = async () => {
    if (token) {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/stations`,
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      const data = await response.json();
      setOptions(data);
    } else {
     // console.log("No token!");
    }
  };

  useEffect(() => {
    ferrit();
  }, []);


  //for the product
  const handleSubmit2 = (e) => {
    e.preventDefault();
    //Insert submitters name
    const token = sessionStorage.getItem("token");
    const user = jwtDecode(token);

    if (selectedOptions.length < 1) {
      alert("Select a station before submitting.");
      return;
    }
    const price0 = all.map((option) => {
      const returnValue = {
        date: date,
        product_id: option.product_id,
        product: option.product,
        by_product_id: option.by_product_id,
        by_product: option.by_product,
        province_id: selectedOptions[0].province_id,
        province: selectedOptions[0].province,
        district_id: selectedOptions[0].district_id,
        station_id: selectedOptions[0].value,
        station: selectedOptions[0].name,
        minimum: option.minimum,
        maximum: option.maximum,
        user_name: user.userName,
      };

      if (option.arrivals) {
        returnValue.arrivals = parseInt(option.arrivals);
      }

      if (option.arrivalsUnit) {
        returnValue.arrivalsUnit = parseInt(option.arrivalsUnit);
      }

      return returnValue;
    });

    const prices = price0.filter((pric) => {
      return pric.minimum != false;
    });

    fetch(`${process.env.REACT_APP_API_URL}/admin/prices`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(prices),
    })
      .then(() => {
        navigateToPrices();
      })
      .catch((err) => {
       // console.log("Unable to add record" + err);
      });
  };

  //dealing with multiple states
  const handleSelectStateOptions = (selectedList) => {
    setSelectedOptions(selectedList);
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="row">
        <div className="col">
          <div style={{ position: "center" }}>
            <form onSubmit={handleSubmit2} className="needs-validation">
              <div class="mb-3" id="tabler">
                <h1>Price Form</h1>

                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <div className="mb-3">
                        <label htmlFor="date" className="form-label">
                          Date
                        </label>
                        <input
                          id="num-value"
                          type="date"
                          className="form-control"
                          min="0"
                          required
                          value={date || ""}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                      {/* Rest of your form */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label for="formGroupExampleInput2" class="form-label">
                      Station
                    </label>
                    <Multiselect
                      options={options}
                      displayValue="name"
                      selectedValues={selectedOptions}
                      onSelect={handleSelectStateOptions}
                      onRemove={(selectedList) => {
                        setSelectedOptions(selectedList);
                      }}
                      closeOnSelect={false}
                      avoidHighlightFirstOption
                      ref={stationRef}
                      selectionLimit={1}
                      required={true}
                    />
                  </div>
                </div>

                <div className="row">
                  <hr style={{color:"white"}}/>
                  <InputFieldPerCotton
                    setter={setAjwain}
                    item={ajwain}
                    value={optionProductsByProducts[21].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setHoney}
                    item={honey}
                    value={optionProductsByProducts[22].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setIspaghol}
                    item={ispaghol}
                    value={optionProductsByProducts[23].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setKalonji}
                    item={kalonji}
                    value={optionProductsByProducts[24].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSaunf}
                    item={saunf}
                    value={optionProductsByProducts[25].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setTukhMalanga}
                    item={tukhMalanga}
                    value={optionProductsByProducts[26].name}
                  ></InputFieldPerCotton>
                </div>
              </div>

              {/**Submit Button */}
              {check && (
                <button
                  type="submit"
                  id="button-submit"
                  className="btn submit-btn"
                >
                  Submit
                </button>
              )}

              {/**Error if min and max values are not agreeing */}
              {displayMessage && (
                <div class="alert alert-danger" id="button-submit" role="alert">
                  Minimum value cannot be greate than maximum value
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      <div>
      </div>
    </>
  );
}
